/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/percentagebar/vertical1/vertical1_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:true});



/* ========== ~~~~~~~~~~ PERCENTAGE BAR : VERTICAL 1 ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class VerticalBar1 extends Component {

	/* <<<<<<<<<< LIFECYCLE FUNCTIONS >>>>>>>>>> */
	constructor(props) {
		super(props);
        this.barCoefficient = 1; // this.props.barCoefficient === undefined ? 1 : this.props.barCoefficient;
        this._interval = null; // needs to be component level to clear it later on dismount
		this.state = {
			percent: 0,
			finished: false,
			endSize: '0%'
		};
	}
	componentDidMount() {
		this.animateBar();
		setTimeout(() => {
			this.setState({ endSize: `${this.barCoefficient * this.props.amount}%` });
		},10);
	}
	componentWillUnmount() {
		this.resetBar();
	}

	/* >>>>>>>>>> CUSTOM FUNCTIONS <<<<<<<<<< */
	animateBar() {
		let localPercent = 1;
	    this._interval = setInterval(() => {
	        if (localPercent >= this.props.amount) {
	            clearInterval(this._interval);
	            this.setState({
	            	finished: true
	            });
	        } else {
	        	localPercent++;
	        	// sheet.getRule('bar').prop('height', `${localPercent}%`); // update stylesheet with ever changing height
	            this.setState({
	            	percent: localPercent
	            });
	        }
	    }, 10);
	}
	resetBar() {
		// make sure this is also called from unmount
		clearInterval(this._interval); // clear interval
	    sheet.getRule('bar').prop('height', `0%`); // reset to 0 for next animation
	}

	/* /////////////// RENDER \\\\\\\\\\\\\\\ */
	render() {
	    return(
	    	<span className={`${sheet.classes.inner} selected-${this.props.isClicked} correct-${this.props.isCorrectAnswer} finished-${this.state.finished}`}>
	        	<span className={`${sheet.classes.bar} bar foreground`} style={{height: `${this.state.endSize}`}}></span>
	        	<span className={`${sheet.classes.number} number`}>{`${this.state.percent}%`}</span>
		    </span>
	    );
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default VerticalBar1;
